import Close from '@mui/icons-material/Close';
import {
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import dayjs from 'dayjs';
import Localization from 'l18n/l18n';
import Appointments from 'models/appointments';
import * as React from 'react';

const DeleteAppointmentDialog = React.forwardRef((props, ref) => {
  const {
    handleCancel,
    setAppointments,
    allAppointments,
    clickedAppointmentInfo,
  } = props;
  const [optionValue, setOptionValue] = React.useState(1);

  const handleOptionChange = (event) => {
    setOptionValue(event.target.value);
  };
  React.useImperativeHandle(ref, () => ({
    save() {
      deleteFromAppointments();
    },
  }));

  const deleteFromAppointments = () => {
    let filiterdAppointment = allAppointments;
    let selectedAppointment = null;
    if (optionValue == '1') {
      filiterdAppointment = allAppointments.filter(
        (appointment) =>
          appointment.appointment_calendar_id !==
          clickedAppointmentInfo.appointment_calendar_id
      );
      selectedAppointment = allAppointments.filter(
        (appointment) =>
          appointment.appointment_calendar_id ==
          clickedAppointmentInfo.appointment_calendar_id
      );
    }
    if (optionValue == '2') {
      filiterdAppointment = allAppointments.filter(
        (appointment) =>
          appointment.appointment_exception_id !==
          clickedAppointmentInfo.appointment_exception_id
      );
      selectedAppointment = allAppointments.filter(
        (appointment) =>
          appointment.appointment_exception_id ===
          clickedAppointmentInfo.appointment_exception_id
      );
    }
    selectedAppointment = selectedAppointment.map((appointment) => ({
      exception_id: appointment.appointment_exception_id,
      start_date: appointment.startDate,
      end_date: appointment.endDate,
      start_time: dayjs(appointment.startDate).format('HH:mm'),
      end_time: dayjs(appointment.endDate).subtract(appointment.schedule_template_time_period,'m').format('HH:mm'),
      all_day: appointment.allDay
    }));

    if (optionValue == '1') {
      Appointments.updateAppointmentException({
        appointments: selectedAppointment,
      }).then(() => {
        setAppointments(filiterdAppointment);
      });
    } else {
      Appointments.deleteAppointmentException(
        clickedAppointmentInfo.appointment_exception_id
      ).then(() => {
        setAppointments(filiterdAppointment);
      });
    }
    handleCancel();
  };

  return (
    <>
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11} className="draggable-dialog-title">
            {Localization.translate['remove_exception']}
          </Grid>
          <Grid item xs={1}>
            <IconButton onClick={() => handleCancel()}>
              <Close />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        <RadioGroup
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={optionValue}
          onChange={handleOptionChange}
        >
          <FormControlLabel
            value="1"
            control={<Radio />}
            label={Localization.translate['remove_this_exception_only']}
          />
          <FormControlLabel
            value="2"
            control={<Radio />}
            label={Localization.translate['remove_repeated_exception']}
          />
        </RadioGroup>
      </DialogContent>
    </>
  );
});
DeleteAppointmentDialog.displayName = 'DeleteAppointmentDialog';
export default DeleteAppointmentDialog;
